"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ramda = require("ramda");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _CalendarSettingDay = _interopRequireDefault(require("./CalendarSettingDay"));

var _userCalendarState = require("./userCalendarState");

var _CalendarSetting = require("./CalendarSetting.shape");

var getAvailabilityPeriodsErrors = (0, _ramda.propOr)({}, 'calendarPeriods');

var CalendarSetting = function CalendarSetting(_ref) {
  var days = _ref.days,
      onSaveCalendar = _ref.onSaveCalendar,
      isLoading = _ref.isLoading,
      errors = _ref.errors;

  var _useCalendarState = (0, _userCalendarState.useCalendarState)({
    days,
    errors: getAvailabilityPeriodsErrors(errors),
    hasErrors: false
  }),
      _useCalendarState2 = (0, _slicedToArray2.default)(_useCalendarState, 2),
      state = _useCalendarState2[0],
      _useCalendarState2$ = _useCalendarState2[1],
      addSlotAction = _useCalendarState2$.addSlotAction,
      removeSlotAction = _useCalendarState2$.removeSlotAction,
      toggleDayAction = _useCalendarState2$.toggleDayAction,
      changeDateAction = _useCalendarState2$.changeDateAction,
      setErrorsAction = _useCalendarState2$.setErrorsAction;

  var daysData = state.days,
      hasErrors = state.hasErrors,
      availabilityErrors = state.errors;
  var addSlotHandler = (0, _react.useCallback)(function (id) {
    return addSlotAction(id);
  }, [addSlotAction]);
  var toggleDayHandler = (0, _react.useCallback)(function (id, enabled) {
    return toggleDayAction({
      id,
      enabled
    });
  }, [toggleDayAction]);
  var removeSlotHandler = (0, _react.useCallback)(function (id, day) {
    return removeSlotAction({
      id,
      day
    });
  }, [removeSlotAction]);
  var changeDateHandler = (0, _react.useCallback)(function (id, day, type, value) {
    return changeDateAction({
      id,
      day,
      value,
      type
    });
  }, [changeDateAction]);
  var handleSavePeriods = (0, _react.useCallback)(function () {
    return onSaveCalendar(daysData);
  }, [daysData, onSaveCalendar]);
  var disabled = (0, _ramda.or)(isLoading, hasErrors);
  (0, _react.useEffect)(function () {
    setErrorsAction(getAvailabilityPeriodsErrors(errors));
  }, [errors, setErrorsAction]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column"
  }, daysData.map(function (day) {
    return /*#__PURE__*/_react.default.createElement(_CalendarSettingDay.default, {
      key: day.id,
      day: day,
      errors: availabilityErrors,
      onToggleDay: toggleDayHandler,
      onAddSlot: addSlotHandler,
      onRemoveSlot: removeSlotHandler,
      onChangeSlotDate: changeDateHandler
    });
  }), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_ui.ActionButton, {
    disabled: disabled,
    onClick: handleSavePeriods
  }, "Save")));
};

CalendarSetting.propTypes = {
  days: _propTypes.default.arrayOf(_CalendarSetting.CalendarDay).isRequired,
  isLoading: _propTypes.default.bool.isRequired,
  onSaveCalendar: _propTypes.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errors: _propTypes.default.object
};
CalendarSetting.defaultProps = {
  errors: {}
};
var _default = CalendarSetting;
exports.default = _default;